import axiosInstance from '../variables/api/axiosInstance';
import { avecLibelleTraduit } from '../i18n/libelles';

/**
 * Messagerie interne entre agents : conversations directes, de groupe, de dossier.
 *
 * CINQUIÈME CANAL, INTERNE COMME LE QUATRIÈME (`discussionService`) - mais ici la
 * conversation est entre PERSONNES, pas ancrée dans un dossier. Rien n'en sort.
 *
 * Toutes les réponses sont enveloppées dans `DataResponse` : on rend `data`.
 */
const base = '/v1/conversations';
const data = (r) => r.data?.data;

export const PRIORITES = avecLibelleTraduit([
  { code: 'NORMAL' },
  { code: 'IMPORTANT' },
  { code: 'URGENT' },
], 'referentiels:prioritesConversation', { cle: 'code', champ: 'libelle' });

const conversationService = {
  lister: () => axiosInstance.get(base).then(data),
  nonLus: () => axiosInstance.get(`${base}/non-lus`, { skipErrorToast: true }).then(data),
  contacts: (q) => axiosInstance.get(`${base}/contacts`, { params: { q } }).then(data),
  creer: (corps) => axiosInstance.post(base, corps).then(data),
  detail: (id) => axiosInstance.get(`${base}/${id}`).then(data),
  ajouterMembres: (id, membres) => axiosInstance.post(`${base}/${id}/membres`, { membres }).then(data),
  quitter: (id) => axiosInstance.delete(`${base}/${id}/membres/moi`).then(data),

  /** `avant` = vers le passé, `depuis` = rattrapage après coupure. */
  messages: (id, { avant, depuis, taille } = {}) =>
    axiosInstance.get(`${base}/${id}/messages`, { params: { avant, depuis, taille } }).then(data),
  envoyer: (id, corps) => axiosInstance.post(`${base}/${id}/messages`, corps).then(data),
  modifier: (messageId, contenu) => axiosInstance.patch(`${base}/messages/${messageId}`, { contenu }).then(data),
  supprimer: (messageId) => axiosInstance.delete(`${base}/messages/${messageId}`).then(data),
  marquerLu: (id, sequence) => axiosInstance.post(`${base}/${id}/lu`, { sequence }).then(data),
  rechercher: (id, q) => axiosInstance.get(`${base}/${id}/recherche`, { params: { q } }).then(data),

  televerser: (id, fichier, { largeur, hauteur, onProgress } = {}) => {
    const fd = new FormData();
    fd.append('fichier', fichier, fichier.name);
    return axiosInstance.post(`${base}/${id}/pieces-jointes`, fd, {
      params: { largeur, hauteur },
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
      },
    }).then(data);
  },
  pieces: (id) => axiosInstance.get(`${base}/${id}/pieces-jointes`).then(data),

  /**
   * Le téléchargement passe par axios (jeton en en-tête) et non par une URL
   * directe : la route est protégée, une balise <img src> sans jeton recevrait 401.
   */
  lirePiece: (pieceId) =>
    axiosInstance.get(`${base}/pieces-jointes/${pieceId}`, { responseType: 'blob' }).then((r) => r.data),
};

export default conversationService;
